<i [attr.data-feather]="icon"></i>
<!-- <i [class]="icon"></i> -->